module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }